import React from 'react';
import T from 'prop-types';
import Body3 from 'components/typography/Body3';
import IconDollarSign from 'assets/IconDollarSign';
import {useBannerSlot} from 'components/BannerStack/BannerStackContext';
import BANNER_STACK_PRIORITY from 'components/BannerStack/priorities';
import {
  CashbackDisableBannerLink,
  CashbackDisableBannerWrapper
} from 'routes/App/cashback/styles';

const CashbackDisabledBanner = ({onEnable}) => {
  const stackIndex = useBannerSlot(
    'cashbackDisabled',
    BANNER_STACK_PRIORITY.cashbackDisabled
  );

  return (
    <CashbackDisableBannerWrapper style={{'--banner-stack-index': stackIndex}}>
      <IconDollarSign />
      <Body3 className='White'>
        Cashback is off — your customers can&apos;t earn or redeem rewards.
        {onEnable && (
          <CashbackDisableBannerLink onClick={onEnable}>
            Click to enable
          </CashbackDisableBannerLink>
        )}
      </Body3>
    </CashbackDisableBannerWrapper>
  );
};

CashbackDisabledBanner.propTypes = {
  onEnable: T.func
};

CashbackDisabledBanner.defaultProps = {
  onEnable: null
};

export default CashbackDisabledBanner;
